export default __webpack_public_path__ + "static/media/blogImage1.5c51346b.jpg";